import React from "react";
import {Link} from "react-router";
import i18n from 'i18n-js';
import { DateRange } from 'react-date-range';
import Packery from "packery";

import moment from "moment";
import alasql from "alasql";

import Right from "./Right";
import DashIcon from "./DashIcon";
import Panel from "./Panel";
import ChartMaker from "./UI/ChartMaker/ChartMaker";
import PanelEditor from "./UI/PanelEditor/PanelEditor";
import CoolLoader from "./CoolLoader";
import CoolLoader2 from "./CoolLoader2";
import Maps from "./Maps";

import langs from "./langs/phpIndex";
import {api, decimals, lastWeekFunc, percent, parsePHPtime, PANEL_TYPES} from "./baseFunctions";
import "./css/main.css";

export default class Dashboard extends React.Component {
	constructor(){
		super();
		this.getData = this.getData.bind(this);
		this.intervalData = this.intervalData.bind(this);
		/*this.redrawCharts = this.redrawCharts.bind(this);
		this.drawGenerel = this.drawGenerel.bind(this);
		this.dateHelper = this.dateHelper.bind(this);*/
		var temp = new Date(2017, 1, 1);
		this.state = {
			data: false,
			selectedDepartment: false,
			departments: [],

			rawReports: [],
			rawObs:[],
			rawUsers: {},

			allObs: [],
			allReports: false,//[],
			allUsers: {},
			leastActive: [],
			locations: [],
			interval: {
				from: moment().startOf("month").unix(),//moment(temp).unix(),
				to: moment().unix()
			},
			//panels: ["RA_POINTS_PIE", "POINTS_LINE", "LAST_RA_TABLE", "RA_COMMENTS"],
			totalPoint: 0,
			totalComments: 0,
			rnd: 0,
			showPicker: false,
			editingPanels: false,
			panels: [],
		};
	}
	componentWillMount(){
		this.chartj1 = false;
		this.chartj2 = false;
		this.getData();
		window.test = Packery;
	}

	getData(){
		api("POST", {"type": "getPanels", page: "dashboard"}, (d) => {
			if(!d.error)
			{
				let panels = [
					/*{type: "OBS_LOCAL_KPI"},
					{
						type: "OBS_LOCAL_MONTH_KPI",
					},*/
					...d.data,
					
				];
				this.setState({panels});
				//this.drawGenerel(this.refs.general);
			}
		}, this.props.auth, 1);
		// api("POST", {"type": "getMyDepartments"}, (d) => {
		// 	if(!d.error)
		// 	{
		// 		this.setState({departments: d.data});
		// 	}
		// }, this.props.auth, 1);
		api("POST", {"type": "getDepartments"}, (d) => {
			if(!d.error)
			{
					  // let rawDeps = {};
					  // let getDeps = (data) => {
					  // 	rawDeps[data.id] = data.name;
					  // 	for(let i = 0; i < data.subDepartments.length; i++)
					  // 	{
					  // 		getDeps(data.subDepartments[i]);
					  // 	}
					  // };
					  // d.data.map((d) => getDeps(d));
				this.setState({
					departments: d.data.ids.map(d => d.name),
					departmentsIDs: d.data.ids,
					depStruct: d.data.data,
			  });
			}
		  }, this.props.auth, 1);

		/*api("POST", {"type": "allReports", "interval": {from: 0, to: moment().unix()}}, (d) => {
			this.setState({rawReports: d.data});
			if(Object.keys(this.state.rawUsers).length > 0)
			{
				//this.redrawCharts();
			}
		}, this.props.auth, 1);

		api("POST", {"type": "allUsers", "interval": this.state.interval}, (d) => {
			this.setState({rawUsers: d.data, rnd: Math.random()*10000});
			if(this.state.rawReports.length > 0)
			{
				//this.redrawCharts();
			}
		}, this.props.auth, 1);
		api("POST", {"type": "getOBSs"}, (d) => {
			console.log("obsRESP", d);
			if(!d.error)
			{
				console.log("Settings OBVSW", d);
				this.setState({rawObs: d.data});
				//this.drawGenerel(this.refs.general);
			}
		}, this.props.auth, 1);*/
		
	}

	redrawCharts()
	{

		const LANG = langs[this.props.lang];
		var d = this.intervalData(this.state.rawReports, this.state.interval.from, this.state.interval.to);
		
		const allUsers = {...this.state.rawUsers};

		var users = {};
		var totalPoints = 0;
		var totalComments = 0;
		d.map((d) => {
				if(!users[d.createdBy])
				{
					users[d.createdBy] = {
						"amount": 0,
						"totalPoints": 0,
						"name": allUsers[d.createdBy].name
					};
				}
				users[d.createdBy].amount++;
				users[d.createdBy].totalPoints += d.points;
				totalPoints += d.points;
			});
		var newUsers = Object.keys(users).map((d, key) => {
				var curr = users[d];
				allUsers[d].amount = curr.amount;
				allUsers[d].totalPoints = curr.totalPoints;
				return {
					"createdBy":{
						"name": curr.name
					},
					"amount": curr.amount,
					"totalPoints": curr.totalPoints
				}
			});
		const leastActive = Object.keys(allUsers).map((d) => allUsers[d]).filter((d) => d.rank > 0).sort((a, b) => a.lastActive > b.lastActive).filter((d, key) => key <= 15).reverse();//.map((usr) => console.log("User", usr));
		//console.log("leastActive", leastActive);
		this.setState({allReports:d, allUsers, totalPoints, leastActive, rnd: Math.random()*10000});
	
    
      
  }

	intervalData(data, start, end, specialTimeName)
	{
		if(!specialTimeName)
		{
			specialTimeName = "time";
		}
		return data.filter((d, key) => {
			//console.log(d, d[specialTimeName], start, d[specialTimeName] > start, d[specialTimeName] < end);
			return d[specialTimeName] > start && d[specialTimeName] < end;
		});
	}

	buildDepOptions(){
		let rows = [];
		let depths = [];
		const getDeps = (dep, depth = 0) => {
			rows.push({
				id: dep.id,
				name: (depth > 0 ? ([...Array(depth)].map(_ => "--").join("") + " ") : "") + dep.name
			});
			depths.push(depth);
			dep.children.map(child => getDeps(child, depth + 1));
		};
		if(this.state.depStruct)
		{
			getDeps(this.state.depStruct);
		}
		// return drawTable(rows, depths.map(i => ({paddingLeft: ((i * 18) + 15) + "px"})));
		return (<select ref="selectedDep" onChange={(e) => this.setState({selectedDepartment: e.target.value === "NaN" ? false : e.target.value})} key={rows.length}>
			<option value="NaN">{i18n.t("Alle afdelinger")}</option>
			{
				rows.map(d => <option value={d.id.toString()} key={d.id}>{d.name}</option>)
			}
		</select>);
	}
	

	
	render(){
		const LANG = langs[this.props.lang];
		//console.log("LANG", LANG, langs, this.props.lang);
		const s = this.state;
		const week = 1*60*60*7;

		return (
			<Right extraPanel={() => <div style={{display: "flex"}} token={this.props.auth}>
																{this.buildDepOptions()}
																<div className="datePicker" onClick={() => this.setState({showPicker: !this.state.showPicker})}>
																	{moment(this.state.interval.from * 1000).format("LL")} - {moment(this.state.interval.to * 1000).format("LL")}
																	<span className=" fa fa-angle-down" style={{paddingLeft: "5px"}}></span>
																</div>
																<div>
																	{
																		this.props.rank === -1 ?
																			<button style={{height: "100%", margin: "0px 10px", width: "50px"}} onClick={() => this.setState({editingPanels: !this.state.editingPanels})}>
																				<i className="fa fa-wrench" aria-hidden="true"></i>
																			</button>
																		: null
																	}
																</div>
															</div>} token={this.props.auth} lang={this.props.lang}>
		
        <div className={"picker " + (this.state.showPicker ? "show" : "hidden")}>
       	<DateRange maxDate={moment()} theme={{DaySelected: {background: '#1ABB9C'}}}
		       	onChange={(d) => {
		       		if(d.startDate.unix() !== d.endDate.unix())
		       		{
			       		this.setState({
			       			interval: {
			       				from: d.startDate.unix(),
			       				to: d.endDate.unix(),
			       			},
			       			showPicker: !this.state.showPicker
			       		});
			       		//console.log(d.startDate.unix(), d.endDate.unix(), d.startDate.unix() == d.endDate.unix());
			       		window.test = d;
			       		//setTimeout(() => this.redrawCharts(), 200);
		       		}
		       	}}
					/>
				</div>

				{
					this.state.editingPanels ?
						<PanelEditor panels={this.state.panels} save={(panels) => {
							api("POST", {"type": "savePanels", page: "dashboard", data: panels}, (d) => {}, this.props.auth, 1);
							this.setState({panels, editingPanels: false});
						}}/>
					: 
						<ChartMaker
							department={this.state.selectedDepartment}
							departments={this.state.departments}
							types={this.state.panels.map((d) => d.type)} 
							cachedAPIs={this.props.cachedAPIs} 
							typeData={this.state.panels} 
							interval={this.state.interval} 
							key={this.state.panels.length  + "-" + this.state.interval.from + "-" + this.state.interval.to + "-" + this.state.selectedDepartment} 
							auth={this.props.auth} 
							lang={this.props.lang}
							
							onReady={() => {
								let test = new Packery(document.querySelector(".chartMaker"), {
									itemSelector: '.panelCont'
								});
							}}
						/>
				}
				
			</Right>);
	}
}


// WEBPACK FOOTER //
// ./src/components/Dashboard.js